import { DRUCKPFAHL, ZUGPFAHL } from "../../../constants";
import { GermanyPfahlkopfZugKunststoff } from "./GermanyPfahlkopfZugKunststoff";
import { GermanyPfahlkopfDruckStahl } from "./GermanyPfahlkopfDruckStahl";
import { GermanyPfahlkopfDruckKunststoff } from "./GermanyPfahlkopfDruckKunststoff";
import { PageWrapper } from "../SmartTitanProjektPDF";
import { GermanyPfahlkopfHead } from "./GermanyPfahlkopfHead";

export function GermanyPfahlkopf({ data }) {
  let isCompression =
    data.Germany.Innere.BeanspruchungausStatik.belastungsartUndRichtung === DRUCKPFAHL;
  let isTension = data.Germany.Innere.BeanspruchungausStatik.belastungsartUndRichtung === ZUGPFAHL;
  let isKunststoff = data.Germany.PileHeadConstruction.werkstoffUebergangsrohr === 0;
  let isStahl = data.Germany.PileHeadConstruction.werkstoffUebergangsrohr === 1;

  return (
    <PageWrapper Deckblatt={data.Deckblatt}>
      <GermanyPfahlkopfHead data={data} />
      {isCompression ? (
        <>
          {/* <GermanyPfahlkopfDruck data={data} /> */}
          {isKunststoff ? <GermanyPfahlkopfDruckKunststoff data={data} /> : null}
          {isStahl ? <GermanyPfahlkopfDruckStahl data={data} /> : null}
        </>
      ) : null}
      {isTension ? (
        <>
          <GermanyPfahlkopfZugKunststoff data={data} />
        </>
      ) : null}
    </PageWrapper>
  );
}
